import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

export const ZDeviceModel = z.object({
  assetModelId: z.string(),
  assetModel: z.string(),
  assetTypeId: z.string()
})

export const ZDeviceModelData = z.array(ZDeviceModel)

export const ZDeviceModelApiResponse = z.object({
  http_status: z.any(),
  data: z.optional(ZDeviceModelData),
  error: z.boolean(),
  error_message: z.optional(z.string())
})

export type DeviceType = z.infer<typeof ZDeviceModel>

export function deviceModelService (
  deviceTypeId: string,
  onSuccess: (assetCategories: DeviceType[], httpStatus: number) => void,
  onFailure: (errorMessage: any, httpStatus: number) => void
): void {
  const url = `/assetrest/api/v2/udp/tiq/assets/models/${deviceTypeId}`

  interceptedAxios
    .get(url, { timeout: 15000 })
    .then((response) => {
      const responseData = response.data

      if (responseData.error === false) {
        if (responseData.data !== null && responseData.data !== undefined) {
          onSuccess(responseData.data, responseData.http_status)
        } else {
          onFailure(responseData.error, responseData.http_status)
        }
      } else {
        onFailure(responseData.error_message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        onFailure(
          error.response.data !== undefined || error.response.data !== null
            ? error.response.data.error_message
            : 'Network Error',
          error.response.status
        )
      } else {
        onFailure('Network Error', 404)
      }
    })
}
